import { render, staticRenderFns } from "./TenantContainer.vue?vue&type=template&id=60347f80&scoped=true"
import script from "./TenantContainer.vue?vue&type=script&lang=js"
export * from "./TenantContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60347f80",
  null
  
)

export default component.exports